import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { NavMenu } from './NavMenu';

export function Layout(props) {
    const [active, setActive] = useState(false);
    const [currentTimer, setCurrentTimer] = useState(0);
    const [authed, setAuthed] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const userString = sessionStorage.getItem("user");
            if (userString === null) {
                setAuthed(false);
                return;
            }
            var sfid = "";
            try {
                const user = JSON.parse(userString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.error("Could not parse userString ", userString);
                console.error("Error message", ex);
            }
            if (sfid === "") {
                setAuthed(false);
                return;
            }
            // auth steps below
            if (props.role === "admin") {
                const result = await fetch('api/admin/GetAdminRoleBySfId/' + sfid)
                    .then(async (response) => {
                        try {
                            const res = await response.json().then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message;
                            });
                            return res;
                        }
                        catch (ex) {
                            console.error("admin user auth error during json conversion: ", ex);
                            return false;
                        }
                    })
                    .catch(ex => {
                        console.error("admin user auth error during json conversion: ", ex);
                        return false;
                    });
                setAuthed(result);
            }
            else if (props.role === "user") {
                const result = await fetch('api/admin/GetHhieUserRoleBySfId/' + sfid + '/' + false)
                    .then(async (response) => {
                        try {
                            const res = await response.json().then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message
                            });
                            return res;
                        }
                        catch (ex) {
                            console.error("hhie user auth error during json conversion: ", ex);
                            return false;
                        }
                    })
                    .catch(ex => {
                        console.error("hhie user auth error during json conversion: ", ex);
                        return false;
                    });
                setAuthed(result);
            }
            // POC
            else {
                var result = await fetch('api/PocUser/PocExistsWithSfId/' + sfid)
                    .then(async (response) => {
                        try {
                            const res = await response.json().then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message;
                            });
                            return res;
                        }
                        catch (ex) {
                            console.error("poc user auth error during json conversion: ", ex);
                            return false;
                        }
                    })
                    .catch(ex => {
                        console.error("poc user auth error during json conversion: ", ex);
                        return false;
                    });
                if (!result) {
                    result = await fetch('api/admin/GetHhieUserRoleBySfId/' + sfid + '/' + true)
                        .then(async (response) => {
                            try {
                                return await response.json().then(json => {
                                    if (json.errors !== null && json.errors !== "") alert(json.errors)
                                    return json.message
                                });
                            }
                            catch (ex) {
                                console.error("hhie user auth error during json conversion: ", ex);
                                return false;
                            }
                        })
                        .catch(ex => {
                            console.error("hhie user auth error during retrieval", ex);
                            return false;
                        })
                }
                setAuthed(result);
            }
            
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (!active) {
            clearTimeout(active);
            setCurrentTimer(setTimeout(() => {
                alert('You have timed out. Please log back in to continue');
                window.location.href = "/logout";
            }, 1000 * 60 * 10));
        }
        else {
            clearTimeout(currentTimer);
        }
    }, [active]);
    var contents = <></>;
    if (authed !== null) {
        contents = authed
            ?
            <div
                onMouseDown={() => { setActive(true) }}
                onKeyDown={() => { setActive(true) }}
                onMouseUp={() => { setActive(false) }}
                onKeyUp={() => { setActive(false) }}
            >
                <NavMenu />
                {props.children}
            </div>
            :
            <Alert variant='danger'>
                You are not authorized to view this page, please try to <Alert.Link>login again</Alert.Link>.
            </Alert>;
    }

    return (
        <>{contents}</>
    );

}
